import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, ArrowLeftIcon } from 'lucide-react';
import { logAccessRequested } from '../utils/accessLog';
interface RequestAccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  onBack: () => void;
  prefillName?: string;
  prefillEmail?: string;
}
export function RequestAccessModal({
  isOpen,
  onClose,
  onBack,
  prefillName = '',
  prefillEmail = ''
}: RequestAccessModalProps) {
  const [name, setName] = useState(prefillName);
  const [email, setEmail] = useState(prefillEmail);
  const [message, setMessage] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Send access request to Google Sheets via webhook
    logAccessRequested(name, email, message);
    setTimeout(() => {
      setIsSubmitted(true);
    }, 600);
  };
  return <AnimatePresence data-id="element-64">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center px-4" data-id="element-65">
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.6
      }} className="absolute inset-0 bg-obsidian/80 backdrop-blur-md" onClick={onClose} data-id="element-66" />

          {/* Modal Card */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 10
      }} transition={{
        duration: 0.6,
        ease: [0.16, 1, 0.3, 1]
      }} className="relative w-full max-w-md bg-charcoal border border-borderline p-8 md:p-10 shadow-2xl z-10" data-id="element-67">
            <button onClick={onClose} className="absolute top-6 right-6 text-muted hover:text-offwhite transition-colors" aria-label="Close modal" data-id="element-68">
              <XIcon className="w-5 h-5" data-id="element-69" />
            </button>

            {isSubmitted ? <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.2
        }} className="text-center py-8" data-id="element-70">
                <h2 className="text-2xl mb-4 text-offwhite" data-id="element-71">
                  Request Received
                </h2>
                <p className="text-muted font-light leading-relaxed" data-id="element-72">
                  Thank you. Your request has been received. We will review and send access
                  credentials shortly.
                </p>
                <button onClick={onClose} className="mt-8 px-6 py-3 border border-borderline text-sm uppercase tracking-widest hover:bg-offwhite hover:text-obsidian transition-colors duration-500" data-id="element-73">
                  Close
                </button>
              </motion.div> : <>
                <button onClick={onBack} className="flex items-center gap-2 text-muted hover:text-offwhite transition-colors text-sm mb-8 tracking-wide" data-id="element-74">
                  <ArrowLeftIcon className="w-4 h-4" data-id="element-75" />
                  Back to Login
                </button>

                <h2 className="text-3xl mb-2 text-offwhite tracking-wide" data-id="element-76">
                  Request Access
                </h2>
                <p className="text-muted text-sm font-light mb-8 leading-relaxed" data-id="element-77">
                  Please provide your details to request a private viewing
                  password.
                </p>

                <form onSubmit={handleSubmit} className="space-y-5" data-id="element-78">
                  <div data-id="element-79">
                    <label htmlFor="req-name" className="block text-xs uppercase tracking-widest text-muted mb-2" data-id="element-80">
                      Name
                    </label>
                    <input id="req-name" type="text" required value={name} onChange={e => setName(e.target.value)} className="w-full bg-obsidian border border-borderline px-4 py-3 text-offwhite focus:outline-none focus:border-muted transition-colors font-light" data-id="element-81" />
                  </div>

                  <div data-id="element-82">
                    <label htmlFor="req-email" className="block text-xs uppercase tracking-widest text-muted mb-2" data-id="element-83">
                      Email
                    </label>
                    <input id="req-email" type="email" required value={email} onChange={e => setEmail(e.target.value)} className="w-full bg-obsidian border border-borderline px-4 py-3 text-offwhite focus:outline-none focus:border-muted transition-colors font-light" data-id="element-84" />
                  </div>

                  <div data-id="element-85">
                    <label htmlFor="req-message" className="block text-xs uppercase tracking-widest text-muted mb-2" data-id="element-86">
                      Additional Information (Optional)
                    </label>
                    <textarea id="req-message" rows={3} value={message} onChange={e => setMessage(e.target.value)} placeholder="Anything you would like us to know about you..." className="w-full bg-obsidian border border-borderline px-4 py-3 text-offwhite focus:outline-none focus:border-muted transition-colors font-light resize-none placeholder:text-muted/30" data-id="element-87" />
                  </div>

                  <button type="submit" className="w-full mt-4 bg-offwhite text-obsidian py-4 text-sm uppercase tracking-widest font-medium hover:bg-white transition-colors duration-500 box-glow-hover" data-id="element-88">
                    Request Access
                  </button>
                </form>
              </>}
          </motion.div>
        </div>}
    </AnimatePresence>;
}